var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8236 5.21087L6.82357 6.28634C6.34694 6.37178 6 6.78643 6 7.27065V16.8983C6 17.3912 6.35916 17.8106 6.84619 17.8864L12.8462 18.8204C13.4525 18.9148 14 18.4459 14 17.8323V6.19518C14 5.57229 13.4367 5.10097 12.8236 5.21087Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H16C16.5523 7 17 7.44772 17 8V16C17 16.5523 16.5523 17 16 17H15",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9L10 12M12 15L10 12M10 12L8 15M10 12L12 9",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcel);
export default __webpack_public_path__ + "static/media/Xcel.153aac4fcf5d609d66d256653269cd7d.svg";
export { ForwardRef as ReactComponent };